<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Cards />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Cards from "../../components/GestionEmpleados/Views/Employee/Cards.vue";
export default {
  components: { LandingToolbar, Cards },
};
</script>
